// extracted by mini-css-extract-plugin
export default {"activeFilterContainer":"activeFilterContainer___vYePo","title":"title___ldMNG","backLinkContainer":"backLinkContainer___L1IA5"};